/**
 * WipWidget — WIP (work in progress) por estacao.
 *
 * Permissao: toc:view. Lista compacta com contagem por estacao.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterDashboardToc } from "../../../services/toc";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "wip",
  label: "WIP por estacao",
  descricao: "Quantas OPs estao em produção em cada estacao agora.",
  categoria: "TOC",
  permissoes: ["toc:view"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterDashboardToc(request, { janela: "30d" });
}

export function Widget({ dados }) {
  const w = dados?.wip;
  if (!w || !Array.isArray(w.por_estacao) || w.por_estacao.length === 0) {
    return (
      <>
        <CardBody>
          <KpiValor>0</KpiValor>
          <KpiSub>Nenhuma OP em produção.</KpiSub>
        </CardBody>
        <CardFooter>
          <LinkLight as={Link} to="/producao/dbr">Ver DBR</LinkLight>
        </CardFooter>
      </>
    );
  }
  const total = w.por_estacao.reduce((s, p) => s + (p.qtd || 0), 0);
  return (
    <>
      <CardBody>
        <KpiValor>{total}</KpiValor>
        <KpiSub>OPs em produção</KpiSub>
        <div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: 4 }}>
          {w.por_estacao.slice(0, 6).map((p) => (
            <div key={p.estacao} style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85rem" }}>
              <span>{p.estacao}</span>
              <strong>{p.qtd}</strong>
            </div>
          ))}
        </div>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/producao/dbr">Ver DBR</LinkLight>
      </CardFooter>
    </>
  );
}
